import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import { Checkbox } from 'semantic-ui-react';

import './LinkPublishedCheckbox.css';


class LinkPublishedCheckbox extends Component {
  static propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkId: PropTypes.number.isRequired,
    idPublished: PropTypes.bool,
  };

  static defaultProps = {
    idPublished: null,
  };

  state = {
    firstChange:  null,
    currentIsPublished: null,
  };

  componentDidMount() {
    this.setState({ currentIsPublished: this.props.isPublished });
  }

  componentDidUpdate(prevProps, prevState) {
    const { linkId, patchLink } = this.props;
    const { currentIsPublished, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsPublished !== this.state.currentIsPublished
    ) {
      patchLink(linkId, { is_published: currentIsPublished });
    }
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentIsPublished: !this.state.currentIsPublished,
    });
  }

  render() {
    const { isPublished } = this.props;
    const { firstChange, currentIsPublished } = this.state;

    return (
      <Checkbox
        className="link-published-checkbox__component"
        toggle
        checked={firstChange ? currentIsPublished : isPublished}
        onChange={this.onCheckboxChange}
      />
    );
  }
}

const mapStateToProps = state => (
  {
    patchLinkError: state.linksReducer.patchLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(LinkPublishedCheckbox);
